import { render, staticRenderFns } from "./data-location-flags.vue?vue&type=template&id=7f5bd9ec&scoped=true"
import script from "./data-location-flags.vue?vue&type=script&lang=js"
export * from "./data-location-flags.vue?vue&type=script&lang=js"
import style0 from "./data-location-flags.vue?vue&type=style&index=0&id=7f5bd9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5bd9ec",
  null
  
)

export default component.exports